import { t } from '../../strings/i18n';
import { required } from '../../xform';
const paymentMethodConfig = () => {
    return [
        'paymentMethod',
        undefined,
        'ENABLED',
        [required(t('errors.paymentMethod'))]
    ];
};
export default paymentMethodConfig;
